import React, { useState, useRef, useEffect } from "react"
import classNames from "classnames"
import { set } from "ramda"

export default function AnimatedButton ({ frames = 1, className, onClick, children }) {
  const [_frame, _setFrame] = useState(0)
  const [running, setRunning] = useState(false)
  const _int = useRef(null)
  const f = useRef(_frame)
  const setFrame = (frame) => {
    _setFrame(frame)
    f.current = frame
  }
  useEffect(() => {
    if (running) {
      _int.current = setInterval(() => {
        const newFrame = f.current === frames ? 0 : f.current + 1
        setFrame(newFrame)
      }, 200)
    } else {
      clearInterval(_int.current)
      setFrame(0)
    }
    return () => {
      clearInterval(_int.current)
      setFrame(0)
    }
  }, [running])
  return (
    <div 
      onMouseOver={() => {
        if (running) return
        setRunning(true)
      }}
      onMouseLeave={() => {
        if (!running) return
        setRunning(false)
      }}
      onMouseUp={() => {
        if (running && onClick) {
          onClick()
        }
      }}
      className={classNames('animated-button', className, 'frame-' + f.current, { running })}>
        {children}
    </div>
  )
}